import React from 'react'
import Grid from '@mui/material/Grid2'
import Link from '@mui/material/Link'

const PlayWithUs: React.FC = () => {
  return (
    <Grid
      container
      direction="column"
      columnSpacing={2}
      justifyContent="center"
      alignItems="center"
      textAlign="center"
    >
      <Grid size={10}>
        <h1>Börja spela med oss</h1>
        <h2>Alla är välkomna! Du kan vara nybörjare eller erfaren</h2>
      </Grid>
      <Grid size={{ xs: 11, md: 6 }} textAlign="start">
        <p>Vi har instrument att låna i viss mån</p>
        <p>Vi anpassar stämmor efter din nivå och ditt instrument</p>
        <p>
          <b>Kostnad för medlemskap:</b>
          <ul>
            <li>Över 18år: 200kr / termin</li>
          </ul>
        </p>
        <p>
          <b>Resor och evenemang:</b>
          Vi åker bland annat till Lübeck, vilket innebär en kostnad för
          deltagare
        </p>
        <p>
          <b>Eget instrument på sikt:</b>
          Om du fortsätter spela hos oss kan det bli aktuellt att köpa ett eget
          instrument
        </p>
        <p>
          <b>Så tar du kontakt:</b>
          Anmäl dig via{' '}
          <Link href="/contact">
            <b>kontaktformuläret</b>
          </Link>{' '}
          eller kom förbi en repetition
        </p>
      </Grid>
      <Grid size={{ xs: 11, md: 6 }}>
        <h4>
          Här övar vi varje måndag: 18:30-ca 20:45, med insluss från 17:30
        </h4>
        <iframe
          title="Google maps karta"
          // eslint-disable-next-line max-len
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1205.412642690732!2d14.887628584852585!3d56.15611855534654!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46568453244f78b1%3A0x36929f8ed1842bab!2sKarlshamns%20Sj%C3%B6scoutk%C3%A5r!5e0!3m2!1sen!2sse!4v1741340880472!5m2!1sen!2sse"
          width="100%"
          height={450}
          style={{
            border: 0,
            borderRadius: 10,
          }}
        />
      </Grid>
      ,
    </Grid>
  )
}

export default PlayWithUs
